import "./App.css";
import Converter from "./components/Converter";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import Game from "./components/Game";
import AppDropdown from "./components/AppDropdown";

// The "App" component holds all the routes for the app.
// Wrapped inside the react-router-dom components "BrowserRouter" and "Routes"
// Above the "Routes" is the "AppDropdown" for the menu so it can be visible on every page.
function App() {
  return (
    <BrowserRouter>
      <AppDropdown />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/converter" element={<Converter />} />
        <Route path="/game" element={<Game />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
